import { Component, OnDestroy, OnInit } from '@angular/core';
import { GetBooksService } from '../../../../shared/services/api/book/get_books.service';
import { BookResponseModel } from '../../../../shared/api-models/responses/book/BookResponseModel';
import { PagesService } from '../../pages.service';
import { Router } from '@angular/router';
import * as fromApp from '../../../../ngrx/app.reducer';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-seasion-list',
  templateUrl: './book-list.component.html',
  styleUrls: ['./book-list.component.scss'],
})
export class BookListComponent implements OnInit, OnDestroy {
  books: BookResponseModel[];
  filterdBooks;
  unsubscribes: Subscription[] = [];
  active: boolean = false;

  constructor(
    // get books
    private getBooksService: GetBooksService,
    private pagesService: PagesService,
    private router: Router,
    private store: Store<fromApp.AppState>
  ) {}

  async ngOnInit() {
    // this.pagesService.gradeId.subscribe(res => {
    //   this.getBooks(res);
    // });
    const sub = await this.store.select('pagesState').subscribe(async(res) => {
      if (await res.gradeId) {
        this.getBooks( await res.gradeId);
        // ریاضی
        // this.getBooks('e6e1856b-8fe8-473f-2f14-08d854881f60')
        // this.getBooks(res.gradeId);
        // تجربی
        // this.getBooks('e76f9105-07a3-4a10-91a7-08d856158a0d')
      }
    });
    this.unsubscribes.push(sub);
  }

  async getBooks(gradeId: string) {
    this.getBooksService.call(gradeId).subscribe(
      async (res) => {
        this.books = await res;
      },
      () => {
        // Todd: error handling
      }
    );
  }

  async getAllBooks(gradeId) {
    this.getBooksService.call(gradeId).subscribe(
      async (res) => {
        this.books = await res;
      },
      (error) => {
        // Todd: error handling
      }
    );
  }

  onBookSelected(bookId: string) {
    this.router.navigate([`/seasons`], { queryParams: { bookId } });
  }

  filterd(id,i) {
  }
  /**
   * on destroy life cycle
   * we unsubscribe all subscription here.
   */
  ngOnDestroy() {
    this.unsubscribes.forEach((x) => x.unsubscribe());
  }
}
